$(document).ready(function () {
  function loadVideoIfInView() {
    $('.lazyvideo').each(function () {
      var $video = $(this);

      // Skip if this video is already loaded
      if ($video.data('loaded')) return;

      var $source = $video.find('source');
      var videoTop = $video.offset().top;
      var scrollTop = $(window).scrollTop();
      var windowHeight = $video.hasClass('banner-video') ? 0 : $(window).height();

      // Check if video is in view (any part of it is visible)
      if (scrollTop + windowHeight > videoTop) {
        var mobileSrc = $source.data('src-mobile');
        var desktopSrc = $source.data('src-desktop');
        var isMobile = $(window).width() < 767;

        var finalSrc = (isMobile && mobileSrc) ? mobileSrc : desktopSrc;

        // Fallback to desktop if mobileSrc is missing
        if (!mobileSrc && isMobile) {
          finalSrc = desktopSrc;
        }

        if (finalSrc) {
          $source.attr('src', finalSrc);
          $video[0].load();
          $video.data('loaded', true); // Mark this video as loaded
        }
      }
    });
  }

  $(window).on('scroll load resize', loadVideoIfInView);
});
